// extracted by mini-css-extract-plugin
module.exports = {"spinner":"loading_spinner__h3nGQ","spinnerIcon":"loading_spinnerIcon__YcZy1","spin":"loading_spin___s27O","spinnerText":"loading_spinnerText___2j26"};